"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _AppDataField = require("../AppDataField");

var _DataField = require("../../../../cms/reducers/designer/CMSReport/DataField");

var _NumAppDataField = require("./NumAppDataField");

var _NumAppDataField2 = _interopRequireDefault(_NumAppDataField);

var _ReportDetailTableRowFieldTemplate = require("../../../containers/reportDetail/ReportDetailTableRowFieldTemplate");

var _ReportDetailTableRowFieldTemplate2 = _interopRequireDefault(_ReportDetailTableRowFieldTemplate);

var _ReportDetailTableFieldTemplate = require("../../../containers/reportDetail/ReportDetailTableFieldTemplate");

var _ReportDetailTableFieldTemplate2 = _interopRequireDefault(_ReportDetailTableFieldTemplate);

var _actions = require("../actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _constants = require("../../../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableAppDataField = function TableAppDataField(dataField, contentDataField, reportData) {
    var _this = this;

    var isWithinTable = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

    _classCallCheck(this, TableAppDataField);

    // Searches within a table if a referenced table row already exists
    // translates raw tcomb form data to TableRow for structured data handling.
    // ATTENTION: This function is indended to identify the row directly based on the current stored value (content)
    // Therefore this only works with tables that HAVE columns set!
    this.tableRowForObjectKeys = function (keys) {
        var firstKey = keys.length > 0 ? keys[0] : null;
        if (!firstKey) {
            console.warn("TableAppDataField.tableRowForObjectKeys: Unable to get firstKey, potentially no columns are available in a TableAppDataField, thus it should have never been initialized", _this.dataField.uid, _this.dataField.title, _this.currentFormValue, _this.reportData, _this.dataField);
            // throw new Error("TableAppDataField.tableRowForObjectKeys: Unable to get firstKey, potentially no columns are available in a TableAppDataField, thus it should have never been initialized");
            return null;
        }
        var row = null;

        var _firstKey$split = firstKey.split(_constants.UIDSEP);

        var _firstKey$split2 = _slicedToArray(_firstKey$split, 2);

        var fieldUid = _firstKey$split2[0];
        var rowUid = _firstKey$split2[1];

        _.chain(_this.rows).forEach(function (tempRow) {
            if (rowUid === tempRow.ref) {
                row = tempRow;
                return false;
            }
        }).value();
        return row;
    };
    this.buildContentDataFromRows = function () {
        return {
            data: {
                rows: _.chain(_this.rows).map(function (row) {
                    return {
                        fields: _.chain(row.appDataFields).map(function (field) {
                            return field.contentDataField;
                        }).value(),
                        ref: row.ref
                    };
                }).value()
            },
            type: "table",
            uid: _this.dataField.uid
        };
    };
    this.generateNewRow = function (appDataFields, refUid) {
        var columnAppDataFields = appDataFields;
        // collect schemas of column data
        return _.chain(columnAppDataFields).map(function (v) {
            var schemaObject = v.appSchemaObject();
            // prefix ids of scheme with ref id
            var prefixedSchemas = {};
            _.chain(schemaObject).forEach(function (value, key) {
                var newKey = key + _constants.UIDSEP + refUid;
                _.set(prefixedSchemas, newKey, value);
            }).value();
            return prefixedSchemas;
        }).thru(function (prefixedSchemas) {
            var schema = {};
            _.chain(prefixedSchemas).forEach(function (prefixedSchema) {
                schema = Object.assign({}, schema, prefixedSchema);
            }).value();
            var tcombSchema = t.struct(schema);
            return {
                schema: tcombSchema,
                ref: refUid,
                appDataFields: columnAppDataFields
            };
        }).value();
    };
    this.generateColumnsOfRow = function (row) {
        return _.chain(_this.columnDataFieldDefinitions).map(function (columnDataFieldDefinition) {
            var rowContent = _.find(row, function (rawColumnData) {
                return columnDataFieldDefinition.uid === rawColumnData.uid;
            });
            return _AppDataField.AppDataFieldFactory.appDataFieldForDataField(columnDataFieldDefinition, rowContent, _this.reportData, true);
        }).value();
    };
    this.appSchemaFieldOptions = function (formattedMessage) {
        var disabled = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

        var field = {};
        _.set(field, _this.key(), {
            label: _this.isWithinTable ? null : _this.dataField.title,
            help: (0, _AppDataField.helpContainer)(true, _this.dataField.description),
            disableAdd: true,
            disableOrder: true,
            disableRemove: true,
            disabled: disabled,
            template: function template(locals) {
                return _this.template(locals, formattedMessage);
            },
            // dynamic item options
            item: function item(value) {
                // finds row for current value
                var row = _this.tableRowForObjectKeys(Object.keys(value));
                // merge schemeoptions of data fields
                var options = {};
                _.chain(Object.keys(value)).forEach(function (key) {
                    var _key$split = key.split(_constants.UIDSEP);

                    var _key$split2 = _slicedToArray(_key$split, 2);

                    var fieldUid = _key$split2[0];
                    var rowUid = _key$split2[1];

                    var appDataField = _.find(row.appDataFields, function (appDataField) {
                        return fieldUid === appDataField.key();
                    });
                    var schemaFieldOptions = appDataField.appSchemaFieldOptions(formattedMessage, disabled);
                    // prefix key of scheme options
                    _.chain(schemaFieldOptions).forEach(function (value, key) {
                        _.set(options, [key + _constants.UIDSEP + row.ref], value);
                    }).value();
                }).value();
                return {
                    fields: options,
                    disabled: disabled,
                    auto: "none",
                    template: function template(locals) {
                        return _this.rowTemplate(locals, formattedMessage);
                    }
                };
            }
        });
        return field;
    };
    this.appSchemaObject = function () {
        var schema = {};
        schema = _defineProperty({}, _this.key(), t.list(_this.rowTypes ? _this.rowTypes : t.struct({})));
        return schema;
    };
    this.appSchemaStruct = function () {
        return t.struct(_this.appSchemaObject(), _this.dataField.uid);
    };
    this.setValue = function (value) {
        value = value || null;
        if (value) {
            _.chain(value).forEach(function (row) {
                var tableRow = _this.tableRowForObjectKeys(Object.keys(row));
                _.chain(row).forEach(function (value, key) {
                    var _key$split3 = key.split(_constants.UIDSEP);

                    var _key$split4 = _slicedToArray(_key$split3, 2);

                    var fieldUid = _key$split4[0];
                    var rowUid = _key$split4[1];

                    var appDataField = _.find(tableRow.appDataFields, function (appDataField) {
                        return fieldUid === appDataField.key();
                    });
                    if (appDataField) {
                        appDataField.setValue(value);
                    }
                }).value();
            }).value();
        }
        _this.contentDataField = _this.buildContentDataFromRows();
    };
    // overwrite current value with new value
    this.addItem = function (dispatch, refUid) {
        // generate empty AppDataFields
        var appDataFields = _this.generateColumnsOfRow([]);
        var row = _this.generateNewRow(appDataFields, refUid);
        _this.rows = _this.rows.concat(Array(row));
        _this.contentDataField = _this.buildContentDataFromRows();
        dispatch(reportDetailActions.updateReportWithAppDataField(_this)).then(function (value) {
            return dispatch(reportDetailActions.saveSelectedReport());
        });
    };
    this.removeItem = function (dispatch, refUid) {
        _this.rows = _.chain(_this.rows).filter(function (row) {
            return row.ref !== refUid;
        }).value();
        var currentFormValue = _this.currentFormValue();
        dispatch(reportDetailActions.updateReportWithAppDataField(_this)).then(function (value) {
            return dispatch(reportDetailActions.saveSelectedReport());
        });
    };
    this.template = function (locals, formattedMessage) {
        var usedUids = _.chain(_this.rows).map(function (row) {
            return row.ref;
        }).value();
        var rowTitles = _.chain(_this.columnDataFieldDefinitions).map(function (dataField) {
            return (0, _AppDataField.labelHelper)(dataField.title, dataField.isMandatory, dataField.isWithinTable, formattedMessage);
        }).value();
        var relevantPropertyDataField = _.find(_this.columnDataFieldDefinitions, function (field) {
            return _this.dataField.minMaxFieldUid === field.uid;
        });
        var minMax = _.chain(_this.rows).map(function (row) {
            var field = _.find(row.appDataFields, function (field) {
                return field.dataField.uid === _this.dataField.minMaxFieldUid && field instanceof _NumAppDataField2.default;
            });
            return field;
        }).filter(function (field) {
            return field;
        }).thru(function (fields) {
            var sorted = _.chain(fields).map(function (field) {
                return field.currentFormValue();
            }).filter(function (formValue) {
                return Number(formValue);
            }).orderBy(function (formValue) {
                return Number(formValue);
            }).value();
            if (sorted.length > 0) {
                return {
                    min: _.head(sorted),
                    max: _.last(sorted)
                };
            } else {
                return null;
            }
        }).value();
        var min = (0, _selectn2.default)("min", minMax);
        var max = (0, _selectn2.default)("max", minMax);
        var minMaxTitle = (0, _selectn2.default)("title", relevantPropertyDataField);
        return React.createElement("div", { style: { width: _AppDataField.containerWidth } }, React.createElement(_ReportDetailTableFieldTemplate2.default, { min: min, max: max, minMaxTitle: minMaxTitle, dataFieldUuid: _this.dataField.uid, usedUids: usedUids, title: _this.dataField.title, addItem: _this.addItem, typeDefinitionUid: _this.dataField.refUid, locals: locals, rowTitles: rowTitles }));
    };
    this.rowTemplate = function (locals, formattedMessage) {
        var currentRow = _this.tableRowForObjectKeys(Object.keys(locals.inputs));
        var rowHasError = false;
        if (currentRow == null) {
            rowHasError = true;
        } else {
            currentRow.appDataFields.forEach(function (field) {
                if (rowHasError) {
                    return;
                }
                var dataField = field.dataField;
                if (dataField.isMandatory) {
                    var data = field.contentDataField.data;
                    if (data.uid !== undefined) {
                        rowHasError = data.uid === null ? true : false;
                    } else if (data.value !== undefined) {
                        rowHasError = data.value === null ? true : false;
                    } else if (data.choices !== undefined) {
                        rowHasError = data.choices === null || data.choices.length === 0 ? true : false;
                    }
                }
            });
        }
        var rowTitles = _.chain(_this.columnDataFieldDefinitions).map(function (dataField) {
            return dataField instanceof _DataField.HeaderDataField ? null : (0, _AppDataField.labelHelper)(dataField.title, dataField.isMandatory, dataField.isWithinTable, formattedMessage);
        }).value();
        return React.createElement(_ReportDetailTableRowFieldTemplate2.default, { rowTitles: rowTitles, title: _this.dataField.title, locals: locals, removeItem: _this.removeItem, refUid: currentRow ? currentRow.ref : null, rowHasError: rowHasError });
    };
    this.key = function () {
        return _this.dataField.uid;
    };
    this.currentFormValue = function () {
        var rowData = [];
        if (_this.rows) {
            _this.contentDataField = _this.buildContentDataFromRows();
            var rows = _.chain(_this.rows).map(function (tableRow, index) {
                var rowData = {};
                _.chain(tableRow.appDataFields).forEach(function (rowAppDefinition) {
                    _.set(rowData, rowAppDefinition.dataField.uid + _constants.UIDSEP + tableRow.ref, rowAppDefinition.currentFormValue());
                }).value();
                return rowData;
            }).value();
            return rows;
        }
        return null;
    };
    this.copy = function () {
        return new TableAppDataField(_this.dataField, _this.contentDataField, _this.reportData);
    };
    this.contentDataField = contentDataField;
    this.dataField = dataField;
    this.reportData = reportData;
    this.isWithinTable = isWithinTable;
    if (dataField.props && dataField.props.fields) {
        this.columnDataFieldDefinitions = _.chain(dataField.props.fields).map(function (dataFieldDefinition) {
            return _DataField.DataFieldFactory.dataFieldForProps(dataFieldDefinition);
        }).value();
    } else {
        this.columnDataFieldDefinitions = [];
    }
    if (contentDataField) {
        var table = contentDataField.data;
        this.rows = _.chain(table.rows).map(function (row) {
            var columnAppDataFields = _this.generateColumnsOfRow(row.fields);
            return _this.generateNewRow(columnAppDataFields, row.ref);
        }).value();
        // build union type
        var typeStructs = _.chain(this.rows).map(function (row) {
            return row.schema;
        }).value();
        if (typeStructs.length > 1) {
            this.rowTypes = t.union(typeStructs, "ListItemUnion");
            this.rowTypes.dispatch = function (value) {
                // extract ref id from object key
                var row = _this.tableRowForObjectKeys(Object.keys(value));
                return row.schema;
            };
        } else if (typeStructs.length === 1) {
            var type = typeStructs[0];
            this.rowTypes = type;
        }
    } else {
        this.rows = [];
    }
    this.contentDataField = Object.assign({}, contentDataField, {
        type: "table",
        uid: dataField.uid
    });
    this.setValue(this.currentFormValue());
};

exports.default = TableAppDataField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/fields/TableAppDataField.tsx
 ** module id = 639
 ** module chunks = 0
 **/